import { render, staticRenderFns } from "./notificationSetting.vue?vue&type=template&id=1bf38f3a&scoped=true"
import script from "./notificationSetting.vue?vue&type=script&lang=js"
export * from "./notificationSetting.vue?vue&type=script&lang=js"
import style0 from "./notificationSetting.vue?vue&type=style&index=0&id=1bf38f3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf38f3a",
  null
  
)

export default component.exports